import {
  ClassTypeEnum,
  FilterData as FilterDataGenerated,
  GetFilterDataApi,
  PouzivatelskaSkupinaSubjekt as PouzivatelskaSkupinaSubjektGenerated,
  Priradeny as PriradenyGenerated,
} from 'pripomienky-web-ts-axios';
import { AxiosRequestConfig } from 'axios';
import apiConfiguration from './configuration/apiConfiguration';
import { ClientResponse } from '../model/ClientResponse';
import FilterData from '../model/filter/FilterData';
import MultiChoiceItem from '../types/MultiChoiceItem';
import { pripomienkyPrefixPath } from './configuration/apiConfigurationConstants';

const client = new GetFilterDataApi(apiConfiguration(pripomienkyPrefixPath));

const map = (generated: FilterDataGenerated): FilterData => ({
  pripomienkujuciSubjektList: generated.pripomienkujuciSubjekt.map(subjekt => mapSubjektItem(subjekt)),
  priradenyList: [...generated.priradeny.map(priradeny => mapPriradenyItem(priradeny)),
    { id: 'isNepriradeny', label: 'Nepriradené', checked: true }],
});

const mapPriradenyItem = (generated: PriradenyGenerated): MultiChoiceItem => ({
  id: generated.id,
  label: generated.label,
  checked: true,
});

const mapSubjektItem = (generated: PouzivatelskaSkupinaSubjektGenerated): MultiChoiceItem => ({
  id: generated.uuid,
  label: generated.kratkeMeno,
  checked: true,
});

// eslint-disable-next-line import/prefer-default-export
export const getFilterData = async (
  classType: ClassTypeEnum,
  type: string,
  year: number,
  index: number,
  options?: AxiosRequestConfig,
):
  Promise<ClientResponse<FilterData>> => {
  const {
    data,
    status,
  } = await client.getFilterData(classType, type, year, index, options);
  return {
    data: map(data),
    responseCode: status,
  };
};
